import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

/**
 *
 */
export default class Step extends withBreakpointObserver(Base) {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Step',
    refs: ['pictures[]', 'scrollbar'],
    options: {
      inactiveBreakpoints: {
        type: String,
        default: 'xxs xs s',
      },
    },
  };

  /** Offset de scroll pour ce step (en %) */
  pinOffset = 0;

  /**
   *
   */
  mounted() {
    this.pinOffset = this.$refs.pictures.length * 75;

    this.tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.$el,
        start: 'top top',
        end: `+=${this.pinOffset}%`,
        pin: true,
        scrub: true,
        onUpdate: (self) => {
          this.$refs.scrollbar.style.transform = `scaleY(${self.progress})`;
        },
      },
    });

    this.$refs.pictures.forEach((element) => {
      this.tl.to(element, {
        y: 0,
        duration: 0.4,
      });
    });
  }
}
